import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { CoreRoute } from '../constants';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const token = this.authService.getToken() || false;
    if (token) {
      return true;
    }
    return this.router.createUrlTree([CoreRoute.Auth]);
  }
}
